<template>
  <v-combobox
    v-model="localValue"
    dense
    :items="items"
    :label="label"
    clearable
    outlined
    class="rounded-pill"
    :error-messages="errorMessages"
    :disabled="disabled"
    :placeholder="placeholder"
    :hint="hint"
    :persistent-hint="persistentHint"
    @input="clearError"
    @update:search-input="onSearchInput"
  />
</template>

<script>
export default {
  name: 'ComboboxFilter',
  props: {
    value: {
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      required: true,
    },
    errorMessages: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    hint: {
      type: String,
      default: "",
    },
    persistentHint: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
  methods: {
    clearError() {
      if (this.errorMessages) {
        this.$emit("clear-error");
      }
    },
    onSearchInput(val) {
      this.$emit('update:search', val);
    },
  }
};
</script>
